export const IS_DEVELOPMENT =
  import.meta.env.DEV || import.meta.env.MODE === 'development';
export const TAWK_API_KEY = import.meta.env.VITE_TAWK_API_KEY;
export const POSTHOG_HOST =
  import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'missing-posthog-host';
export const POSTHOG_KEY =
  import.meta.env.VITE_PUBLIC_POSTHOG_KEY || 'missing-posthog-key';
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'no-url-set';
export const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY || 'no-anon-key-set';

export const API_URL = `${SUPABASE_URL}/functions/v1`;
export const PUBLIC_API = `${API_URL}/public-api`;
export const SECURED_API = `${API_URL}/api`;

export const IS_PRODUCTION =
  SUPABASE_URL !== 'https://uwhlqmezhlabjsyrbelb.supabase.co';

export const TRACKING_ENABLED = IS_PRODUCTION && !IS_DEVELOPMENT;
